import { builder } from '@builder.io/react'
import '@builder.io/widgets'
import './custom-components/vimeo'
import './custom-components/original-price'
import './custom-components/discounted-price'
import './custom-components/percent-off'
import './custom-components/add-to-cart'
import './custom-components/try-it-free'
builder.init('47c5d023e7b3451a86ac03602c65dce8')
